import React from 'react'
import { useTranslation } from 'react-i18next'

import { WidgetLayout } from '@/pages/Buy/WidgetLayout'
import { DarkModeMenu } from '@/panels/signup/DarkmodeSignUpPanel'
import { usePageStateStore } from '@/reducers/'
import { KYCRefreshForm } from './KYCRefreshForm'

const KYCRefreshInfoComponent = () => {
  const { t } = useTranslation()
  const authToken = usePageStateStore.use.authToken() || ''

  return (
    <WidgetLayout showInteracLabel={false} showPoweredByLabel={false}>
      <DarkModeMenu />
      <div
        className="flex items-start justify-center min-h-screen overflow-y-auto pt-24"
        data-testid="container-upload"
      >
        <div
          className="w-full dark:text-white pb-8"
          style={{
            position: 'relative',
            width: '90%',
            maxHeight: 'calc(100vh - 6rem)',
            overflowY: 'auto',
          }}
          data-testid="container-kyc-refresh-form"
        >
          <div
            className="text-lg font-normal uppercase justify-center items-center text-center"
            style={{ paddingBottom: '20px' }}
            data-testid="text-kyc-refresh-title"
          >
            {t('kycRefresh.title')}
          </div>
          <p className="mb-2">{t('kycRefresh.subtitle')}</p>

          <KYCRefreshForm authToken={authToken} />
        </div>
      </div>
    </WidgetLayout>
  )
}

export const KYCRefreshInfo = React.memo(KYCRefreshInfoComponent)
